import { defineMessages } from 'react-intl';

export default defineMessages({
  civilPartyBlocTitle: {
    id: 'legal_proceeding_page.judgement_add.civil_party.emtpy_state.title',
  },
  civilPartyEmptyStateSubTitle: {
    id: 'legal_proceeding_page.judgement_add.civil_party.emtpy_state.sub_title',
  },
  civilPartyEmptyStateButton: {
    id: 'legal_proceeding_page.judgement_add.civil_party.emtpy_state.button',
  },
  uploadTitle: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.add_in_writing_judgement_bloc.upload_title',
  },
  uploadButton: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.add_in_writing_judgement_bloc.upload_button',
  },
  victimTitle: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.add_in_writing_judgement_bloc.victim_title',
  },
  saveButton: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.add_in_writing_judgement_bloc.save_button',
  },
  cancelButton: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.add_in_writing_judgement_bloc.cancel_button',
  },
  documentType: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.add_in_writing_judgement_bloc.doc_type',
  },
  documents: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.documents',
  },
  supportDocument: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.support_document',
  },
  victims: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.victims',
  },
  addButton: {
    id: 'legal_proceeding_page.judgement_add.civil_party.add.button',
  },
  civilPartyRecapTitle: {
    id: 'legal_proceeding_page.judgement_add.civil_party.recap_title',
  },
  deleteCivilParty: {
    id: 'legal_proceeding_page.judgement_add.civil_party.recap.delete_title',
  },
  editCivilParty: {
    id: 'legal_proceeding_page.judgement_add.civil_party.recap.edit_title',
  },
});
